import React, { MouseEventHandler, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Button.module.scss';

export const Button = ({ children, onClick, title, ...props }: Props) => (
    <div onClick={onClick} className={classes(props)} title={title}>
        {children}
    </div>
);

const classes = ({ className, textOnly, disabled, small, border, white }: Props) => {
    return classNames(styles.default, 'idt-button', className, {
        [styles.textOnly]: textOnly,
        'idt-button--text-only': textOnly,
        [styles.white]: white,
        'idt-button--white': white,
        [styles.small]: small,
        'idt-button--small': small,
        [styles.disabled]: disabled,
        'idt-button--disabled': disabled,
        [styles.border]: border,
        'idt-button--border': border,
    });
};

type Props = PropsWithChildren<{
    onClick?: MouseEventHandler,
    className?: string,
    textOnly?: boolean,
    small?: boolean,
    border?: boolean,
    white?: boolean,
    disabled?: boolean,
    title?: string
}>;